import {API_URL, THEME_COLOR, numberWithCommas, CMS_URL} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import HeaderClose from "../layout/HeaderClose";
import Slider from "react-slick"
import { useLocalStorage } from "../useLocalStorage";
import $ from "jquery";
import M from "materialize-css";
import Warehouse from "./component/Warehouse";
import Address from "./component/Address";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SlidingPane from 'react-sliding-pane';
import "react-sliding-pane/dist/react-sliding-pane.css";

import toast, { Toaster } from 'react-hot-toast';


import banner1 from "../logo.svg"
import banner2 from "../images/bst_banner.jpg"
import deliver from "../images/icon/deliveryman.svg"

import "./Item.css";

const PopUp = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [wh, setWh] = useLocalStorage("wh", "");
    const [qty, setQty] = useState(1);
    const [shippingMethod, setShippingMethod] = useState('PICKUP');
    const [itemPrice, setItemPrice] = useState(0)
    const [address, setAddress] = useState({})
    const [warehouse, setWarehouse] = useState({})
    const [warehouses, setWarehouses] = useState({})
    const [promoHeader, setPromoHeader] = useState([]); 
    const [promoDetail, setPromoDetail] = useState([]); 
    const [itemPromo, setItemPromo] = useState([])
    const [isOpenAddress, setIsOpenAddress] = useState(false);
    const [isOpenWarehouse, setIsOpenWarehouse] = useState(false);

    function getStock(){
        
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("x-wh", wh);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/stock/${props.itemunitid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getPromoItem(){
        var requestOptions = {
            method: 'GET',
            // body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/promo/items/${props.itemunitid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    useEffect(async ()=>{
        let promos = await getPromoItem();
        if(promos.status == 200){
            if(promos.data.header){
                setPromoHeader(promos.data.header)
                setPromoDetail(promos.data.detail)
            }
        }

        let data = await getStock();
        if(data){
            if(data.status == 200){
                data = data.data;
                setWarehouses(data)
                if(data && data.length>0){
                    setWarehouse({
                        ID: data[0].WarehouseID,
                        CompanyID: data[0].CompanyID,
                        BranchID: data[0].BranchID,
                        WarehouseID: data[0].WarehouseID,
                        Name : data[0].WarehouseName,  
                        Stock : data[0].QtyEnd,  
                        CityID: data[0].CityID,
                        CityName : data[0].CityName,
                        ProvinceID: data[0].ProvinceID,
                        ProvinceName: data[0].ProvinceName,
                        Address : data[0].WarehouseAddress,  
                    })
                }else{
                    setWarehouse({
                        ID: 0,
                        Name: "",
                        Stock: 0,
                    })
                }
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    function getDefaultAddress(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/defaultaddress`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }


    useEffect(async ()=>{
        let el = document.getElementById("tabs");
        let options = {};
        var instance = M.Tabs.init(el, options);
        let response = await getDefaultAddress();
        if(response.status == 200){
            let val = response.data;
            setAddress({
                ID: val.ID,
                Alias: val.Name,
                Name: "",
                Phone: val.MobilePhone,
                Address: val.Address,
                District: val.VillageName,
                City: val.CityName,
                Province: val.ProvinceName,
                ZipCode: val.ZipCode,
                Nation: val.CountryName,
                VillageID: val.VillageID,
                DistrictID: val.DistrictID,
                RegencyID: val.RegencyID,
                CityID: val.CityID,
                ProvinceID: val.ProvinceID,
                CountryID: val.CountryID
            })
        }else{
            setAddress({
                ID: 0,
                Alias: "",
                Name: "",
                Phone: "",
                Address: "",
                District: "",
                City: "",
                Province: "",
                Nation: "",
            })
        }
    },[]);

    function changeIsOpenAddress(val){
        setIsOpenAddress(val);
    }

    function changeIsOpenWarehouse(val){
        setIsOpenWarehouse(val)
    }

    async function decrementQty(){
        await setQty(parseInt(qty) - 1);
        if(qty < 2){
            setQty(1);
        }
        props.prices.forEach(element => {
            let tqty = qty -1;
            if(tqty >= element.Qty){
                setItemPrice(element.Price);
            }
        });
    }

    function incrementQty(){
        setQty(parseInt(qty) + 1);
        props.prices.forEach(element => {
            let tqty = qty + 1;
            if(tqty >= element.Qty){
                setItemPrice(element.Price);
            }
        });
    }

    async function qtyChange(e){
        await setQty((!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value));
        if(qty < 1){
            setQty(1);
        }
        props.prices.forEach(element => {
            let tqty = parseInt(e.target.value);
            if(tqty >= element.Qty){
                setItemPrice(element.Price);
            }
        });
    }

    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }

    function postCart(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("ShipmentMethod", (shippingMethod == "SHIP BY") ? address.ID : 0);
        urlencoded.append("AddressID", (shippingMethod == "SHIP BY") ? address.ID : 0);
        urlencoded.append("CompanyID", warehouse.CompanyID);
        urlencoded.append("BranchID", warehouse.BranchID);
        urlencoded.append("WarehouseID", warehouse.WarehouseID);
        urlencoded.append("DiscountPercent", 0);
        urlencoded.append("DiscountAmount", 0);
        urlencoded.append("Total", ((itemPrice === 0) ? props.itemprice : itemPrice) * qty);
        urlencoded.append("ItemID", props.itemid);
        urlencoded.append("ItemName", props.itemname);
        urlencoded.append("ItemUnitID", props.itemunitid);
        urlencoded.append("ItemPrice", (itemPrice === 0) ? props.itemprice : itemPrice);
        urlencoded.append("Qty", qty);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/cart`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function getAvailableStock(){
        
        var urlencoded = new URLSearchParams();
        urlencoded.append("type", "Ecommerce_Available_Stock");
        urlencoded.append("row", 1);

        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/configuration`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function postPromo(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("ShipmentMethod", (shippingMethod == "SHIP BY") ? address.ID : 0);
        urlencoded.append("AddressID", (shippingMethod == "SHIP BY") ? address.ID : 0);
        urlencoded.append("CompanyID", warehouse.CompanyID);
        urlencoded.append("BranchID", warehouse.BranchID);
        urlencoded.append("WarehouseID", warehouse.WarehouseID);
        urlencoded.append("DiscountPercent", 0);
        urlencoded.append("DiscountAmount", 0);
        urlencoded.append("Total", ( itemPromo.reduce( (a,b) => a + (b.Qty * b.CatalogPrice), 0) ));
        urlencoded.append("Items", JSON.stringify(itemPromo));


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/cart/promo`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function addToCart(){
        let allow = true;
        if(shippingMethod == "SHIP BY" && (!address || address.ID == 0)){
            toast.error("Select shipping address!")
            allow = false;
        }
        if(!warehouse || warehouse.ID == 0){
            toast.error("Select warehouse!")
            allow = false;
        }
        if(allow){
            // console.log(shippingMethod)
            let response = await postCart();
            response = JSON.parse(response);
            if(response.status == 200){
                window.location = '/cart';
            }else{
                toast.error(response.message);
            }
        }
    }

    function minPromoQty(id){
        let inpt = document.getElementById(`promo-qty-${id}`);
        let val = parseInt(inpt.value);
        
        val -= 1
        if(val < 1) val = 1
        inpt.value = val;

        let titempromo = [...itemPromo];
        let titem = null;
        let itemidx = titempromo.findIndex(value => value.ID === id)
        if(itemidx >= 0){
            titem = titempromo[itemidx];
            titem.Qty = val;
            titempromo[itemidx] = titem;
            setItemPromo(titempromo);
        }
        // recalculate();
    }

    function addPromoQty(id){
        let inpt = document.getElementById(`promo-qty-${id}`);
        let val = parseInt(inpt.value);

        val += 1
        inpt.value = val;

        let titempromo = [...itemPromo];
        let titem = null;
        let itemidx = titempromo.findIndex(value => value.ID === id)
        if(itemidx >= 0){
            titem = titempromo[itemidx];
            titem.Qty = val;
            titempromo[itemidx] = titem;
            setItemPromo(titempromo);
        }
        // recalculate();
    }

    function pressPromoQty(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }

    function changePromoQty(id){
        let inpt = document.getElementById(`promo-qty-${id}`);
        let val = 0;
        if(inpt.value && inpt.value !== "")
            val = parseInt(inpt.value);
        inpt.value = val;

        let titempromo = [...itemPromo];
        let titem = null;
        let itemidx = titempromo.findIndex(value => value.ID === id)
        if(itemidx >= 0){
            titem = titempromo[itemidx];
            titem.Qty = val;
            titempromo[itemidx] = titem;
            setItemPromo(titempromo);
        }
        // let titem = 
        // recalculate();
    }
    

    function changePromoCheck(item){
        let cb = document.getElementById(`checkbox-${item.ID}`)
        let titempromo = [];
        if(itemPromo.length > 0) titempromo = [...itemPromo];
        if(cb.checked){
                item.Qty = parseInt(document.getElementById(`promo-qty-${item.ID}`).value)
                titempromo.push(item);
        }else{
            titempromo = titempromo.filter(value => value.ID !== item.ID)
        }
        setItemPromo(titempromo);
        // recalculate();
    }

    function recalculate(){
        let titemPromo = [...itemPromo]

        titemPromo.map((value, index)=>{
            titemPromo[index].Qty = parseInt(document.getElementById(`promo-qty-${value.ID}`).value);
        })

        setItemPromo(itemPromo);
    }

    async function submitPromo(){
        let selecteditem = {};
        let totalpackage = 0;
        let valid = true;

        itemPromo.forEach((value, index)=>{
            if(!selecteditem[value.ItemType]){
                selecteditem[value.ItemType] = {}
                selecteditem[value.ItemType][value.ItemGroupID] = value.Qty
            }
            else if(!selecteditem[value.ItemType][value.ItemGroupID]){
                selecteditem[value.ItemType][value.ItemGroupID] = value.Qty
            }
            else{
                selecteditem[value.ItemType][value.ItemGroupID] += value.Qty
            }
        })
        
        promoHeader.forEach((value, index)=>{
            let ttotalpackage = Math.ceil(selecteditem[value.ItemType][value.ItemGroupID] / value.Qty)
            if(ttotalpackage > totalpackage) totalpackage = ttotalpackage;    
        })

        
        
        promoHeader.forEach((value, index)=>{
            if(!selecteditem || !selecteditem[value.ItemType] || !selecteditem[value.ItemType][value.ItemGroupID]){
                valid = false;
                return;
            }
            
            if(selecteditem[value.ItemType][value.ItemGroupID] % (totalpackage * value.Qty) !== 0){
                valid = false;
            }
        })

        if(valid){
            toast.success("Promo match!")
            let response = await postPromo();
            if(response.status == 200){
                window.location = '/cart';
            }else{
                toast.error(response.message);
            }
        }else{
            toast.error("Promo doesn't match!")
        }
    }

    useEffect(()=>{
        recalculate();
    })

    return (
        <>
            <Toaster
                position="bottom-center"
            />
            <div className="popup-container" id={`${props.id}`}>
                <HeaderClose title="Shipping" />
                <div className="shipping-container">
                    <div className="shipping-item-container">
                        <div className="shipping-flex-container">
                            <div className="shipping-item-image">
                                <img src={`${CMS_URL}/images/upload/product/${props.itemcode}/${props.itemimage.ImageName}`} />
                            </div>
                            <div className="shipping-item-detail">
                                <p className="detail-item-name">{props.itemname}</p>
                                <p className="detail-item-price">Rp {numberWithCommas((itemPrice === 0) ? props.itemprice : itemPrice)}</p>
                                <p className="detail-promo-color">Color: {props.itemcolor}</p>
                                <p className="detail-promo-color">Size: {props.itemsize}</p>
                                <p style={{fontSize:"10pt"}}>Weight: {props.itemweight} kg</p>
                            </div>
                        </div>
                    </div>
                    <div className="shipping-flex-container" style={{alignItems:"center"}}>
                        <div className="shipping-flex-grow">Qty:</div>
                        <div className="detail-flex-item">
                            <button className="detail-rounded-btn" onClick={decrementQty}>-</button>
                        </div>
                        <div className="detail-flex-item" style={{textAlign:"center"}}>
                            <input type="text" value={qty} onChange={qtyChange} onKeyPress={qtyKeyPress}/>
                        </div>
                        <div className="detail-flex-item">
                            <button  className="detail-rounded-btn" onClick={incrementQty}>+</button>
                        </div>
                    </div>
                    <div className="shipping-flex-container">
                        <div className="shipping-flex-grow">Total Weight:</div>
                        <div><strong>{(props.itemweight * qty).toFixed(2)} Kg</strong></div>
                    </div>
                </div>
                <div className="shipping-container">
                    <div className="detail-header">Shipping Method</div>
                    <div className="row">
                        <div className={`col s12`}>
                            <ul className="tabs" id="tabs">
                                <li className="tab col s6" onClick={ e=>{setShippingMethod("PICKUP")} }><a href="#test1">Pickup</a></li>
                                <li className="tab col s6" onClick={ e=>{setShippingMethod("SHIP BY")} }><a href="#test2">Delivery</a></li>
                            </ul>
                        </div>
                        <div id="test1" className="col s12">
                            <div className="shipping-flex-container" style={{display:"none"}}>
                                <div className="shipping-item-image" style={{display:"none"}}>
                                    <img src={deliver} width={80} height={80}></img>
                                </div>
                                <div className="shipping-item-detail center">
                                    <p className="detail-item-name">PICKUP</p>
                                    <p style={{fontSize:"10pt"}}>Select the address where you like to pickup the package..</p>
                                </div>
                            </div>
                        </div>
                        <div id="test2" className="col s12">
                            <p className="detail-item-name">Destination</p>
                            <div className="shipping-info-container" style={{padding:"10px"}}>
                                <div className="shipping-information-header">{address.Alias}</div>
                                <div className="shipping-information-header">{address.Name}</div>
                                <div>{address.Phone}</div>
                                {(address.Address && address.Address != "")? (
                                <div>{address.Address},{address.District},{address.City},{address.Province},{address.Nation}</div>) : <></>}
                                <hr/>
                                <div className="right-align">
                                    <button className={`btn ${THEME_COLOR}`} onClick={()=> setIsOpenAddress(true)}>Change</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="shipping-container">
                    <div className="detail-header">{(shippingMethod == "PICKUP") ? "Pick Up " : "Sender "}Address</div>
                    <div style={{marginBottom:"20px"}}>
                        <div className="shipping-info-container" style={{padding:"10px"}}>
                            <div className="shipping-information-header">{warehouse.Name}</div>
                            {(props.availStockConfig == 1) ? <div className="shipping-information-header">Stock: {warehouse.Stock}</div> : <></>}
                            <div></div>
                            {(warehouse.CityName && warehouse.CityName != "") ? (
                            <div>{warehouse.Address}, {warehouse.CityName}, {warehouse.ProvinceName}, Indonesia</div>) : <></>}
                            <hr/>
                            <div className="right-align">
                                <button className={`btn ${THEME_COLOR}`} onClick={()=> setIsOpenWarehouse(true)}>Change</button>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    (promoDetail.length > 0) ?(
                        
                        <div className="shipping-container">
                            <div className="detail-header">Promo</div>
                            <div>
                                <pre style={{whiteSpace:"pre-wrap"}}>
                                    {(promoHeader[0])? promoHeader[0].Description : ""}
                                </pre>
                            </div>
                            <div className="detail-promo-container">
                                {
                                    promoDetail.map((value, index)=>{
                                        let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                                        if(value.ImageName){
                                            imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                                        }
                                        return (
                                            <div className="detail-promo-flex" style={{"borderBottom": "1px solid #aaa"}}>
                                                <div className="detail-promo-left">
                                                    <label>
                                                    {/* defaultChecked={(value.HeaderPriority === 1 && value.Priority === 1) ? "checked" : ""} */}
                                                        <input type="checkbox" id={`checkbox-${value.ID}`} className="checkbox-promo" onChange={()=>changePromoCheck(value)}/>
                                                        <span></span>
                                                    </label>
                                                </div>
                                                <div className="detail-promo-left">
                                                    <img src={imgurl} className="detail-promo-image"/>
                                                </div>
                                                <div className="detail-promo-right">
                                                    <div className="detail-promo-name">{value.ItemName}</div>
                                                    <div className="detail-promo-price">Rp. {numberWithCommas(value.CatalogPrice)}</div>
                                                    <div className="detail-promo-color">{value.ItemColor}</div>
                                                    <div className="detail-promo-size">{value.ItemSize}</div>
                                                    <div className="detail-promo-flex" style={{"padding": "0"}}>
                                                        <div className="detail-promo-qty">
                                                            <div className="detail-promo-boxside" onClick={()=> minPromoQty(value.ID)}>-</div>
                                                            <div className="detail-promo-boxmid"><input type={"text"} onKeyPress={pressPromoQty} onChange={()=>changePromoQty(value.ID)} name="" id={`promo-qty-${value.ID}`} style={{"height":"1.5rem","fontSize":"12pt"}} defaultValue={(value.HeaderPriority === 1 && value.Priority === 1) ? value.Qty : 0}/></div>
                                                            <div className="detail-promo-boxside" onClick={()=> addPromoQty(value.ID)}>+</div>
                                                        </div> 
                                                        {itemPromo.filter((val,idx)=> val.ItemGroupID === value.ItemGroupID && val.ItemType == value.ItemType).reduce((a, b) => a + b.Qty, 0)}
                                                        {promoHeader.filter((val,idx)=> val.ItemGroupID === value.ItemGroupID && val.ItemType == value.ItemType).map((obj, idx)=> (` / ${obj.Qty}`))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div className="detail-promo-flex">
                                    <div className="shipping-flex-grow">
                                        <div>Sub Total</div>
                                        <div className="detail-promo-price">Rp. { numberWithCommas(itemPromo.reduce((a,b)=> a + (b.Qty * b.CatalogPrice), 0)) }</div>
                                    </div>
                                    <div className="shipping-footer-right" onClick={ ()=> submitPromo() }>
                                        Add Promo
                                    </div>
                                </div>
                            </div>
                            <div style={{height: "50px"}}>
                            </div>
                        </div>
                    ):(
                        <></>
                    )
                }
                <div style={{marginBottom:"40px"}}></div>
                <div style={{position:"fixed", bottom:"0", width: "100%", maxWidth:"480px"}}>
                    <div className="shipping-footer white">
                        <div className="shipping-flex-grow">

                        </div>
                        <div className="shipping-footer-right" onClick={ addToCart }>
                            Add To Cart
                        </div>
                    </div>
                </div>
            </div>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenWarehouse}
                title="Choose Warehouse"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenWarehouse(false)}
            >
                <Warehouse
                    warehouses = {warehouses}
                    changeIsOpenWarehouse = {changeIsOpenWarehouse}
                    setWarehouse = {setWarehouse}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenAddress}
                title="Choose Address"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenAddress(false)}
            >
                <Address
                    setAddress = {setAddress}
                    changeIsOpenAddress = {changeIsOpenAddress}
                />
            </SlidingPane>
        </>
    );
}

const Item = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [lastViewedItem, setLastViewedItem] = useLocalStorage("lastViewedItem", "");
    const [itemID, setItemID] = useState(0);
    const [itemName, setItemName] = useState("");
    const [itemPrices, setItemPrices] = useState([]);
    const [itemPrice, setItemPrice] = useState(0);
    const [itemDetail, setItemDetail] = useState("");
    const [itemColor, setItemColor] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [itemSize, setItemSize] = useState("");
    const [itemCategory, setItemCategory] = useState("");
    const [itemWeight, setItemWeight] = useState(0);
    const [itemCapacity, setItemCapacity] = useState(0);
    const [warehouses, setWarehouses] = useState([]);
    const [itemImages, setItemImages] = useState([]);
    const [availStockConfig, setAvailStockConfig] = useState({});

    const settingsBanner = {
        dots: true,
        autoplay: false,
        infinite: false,
        arrows: false,
        className: "banner-slider",
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const settingsCategory = {
        dots: true,
        infinite: false,
        arrows: false,
        className: "category-slider",
        // speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3
    };

    function getItemPrice(){
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/price/${props.match.params.itemid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getAvailableStock(){
        
        var urlencoded = new URLSearchParams();
        urlencoded.append("type", "Ecommerce_Available_Stock");
        urlencoded.append("row", 1);

        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/configuration`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getItem(){
        var requestOptions = {
            method: 'GET',
            // body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/${props.match.params.itemid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getStock(){
        var requestOptions = {
            method: 'GET',
            // body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/stock/${props.match.params.itemid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getImage(itemid){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/image/${itemid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function addToCart(){
        if(token){
            $("#popup").show();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }else{
            setLastViewedItem(itemID);
            window.location = '/login';
        }
    }

    useEffect(async ()=>{
        let data = await getItem();
        if(data){
            if(data.status == 200 && data.data){
                data = data.data;
                setItemID(data.ID);
                setItemName(data.Name);
                setItemPrice(data.CatalogPrice);
                setItemCode(data.Code);
                setItemCategory(data.CategoryName);
                setItemColor(data.Color);
                setItemSize(data.Size);
                setItemWeight(data.Weight);
                setItemCapacity(data.Capacity);
                
                let response = await getImage(data.ID);
                if(response){
                    if(response.status == 200){
                        setItemImages(response.data);
                    }else{
                        toast.error(data.message)
                    }
                }else{
                    toast.error("couldn't connect to server")
                }
            }else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
        let response = await getAvailableStock();
        if(response && response.status == 200){
            setAvailStockConfig(response.data)
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    useEffect(async ()=>{
        let data = await getStock();
        if(data){
            if(data.status == 200){
                data = data.data;
                setWarehouses(data)
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    useEffect(async ()=>{
        let data = await getItemPrice()
        if(data){
            if(data.status == 200){
                data = data.data;
                let prices = [];
                data.forEach(element => {
                    prices.push({
                        Qty: element.Qty,
                        Price: element.CatalogPrice
                    })
                });
                setItemPrices(prices);
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
    },[])

    return (
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <div style={{position:"relative"}}>
                <PopUp
                    id="popup"
                    itemid = {itemID}
                    itemunitid={props.match.params.itemid}
                    itemname = {itemName}
                    itemprice = {itemPrice}
                    itemcode = {itemCode}
                    itemcolor = {itemColor}
                    itemsize = {itemSize}
                    itemcategory = {itemCategory}
                    itemweight = {itemWeight}
                    itemcapacity = {itemCapacity}
                    itemimage = {(itemImages.length > 0 ) ? itemImages[0] : ""}
                    prices = {itemPrices}
                    availableStockConfig = {availStockConfig}
                    toke = {token}
                />
                <HeaderBack title="Detail" />
                <div className="detail-container">
                    <Slider {...settingsBanner}>
                        {
                            itemImages.map((value, index)=>{
                                let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                                if(value.ImageName){
                                    let code = value.ImageName.split("_")[0];
                                    imgurl = `${CMS_URL}/images/upload/product/${code}/${value.ImageName}`;
                                }
                                return(
                                    <div>
                                        <img src={imgurl}/>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
                <div className="detail-container">
                    <div className="detail-item-name">{itemName}</div>
                    <div className="detail-item-price">Rp. {numberWithCommas(itemPrice)}</div>
                    {
                        (itemPrices && false)?
                        (
                            itemPrices.map((value, index)=>{
                                if(value.Qty !== 1){
                                    return (
                                        <div>
                                            <span>buy {value.Qty} for @ Rp. {numberWithCommas(value.Price)}</span>
                                        </div>
                                    );
                                }
                            })
                        ):
                        (
                            <></>
                        )
                    }
                </div>
                {
                    (availStockConfig.Value == 1) ?(

                        <div className="detail-container">
                            <div className="detail-header">Stock Available</div>
                            <div>
                                <table className="striped centered">
                                    <thead>
                                        <tr>
                                            <th>Warehouse</th>
                                            <th>City</th>
                                            <th>Stock</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            warehouses.map((val, index)=>{
                                                if(index < 5)
                                                return (
                                                    <tr>
                                                        <td>{val.WarehouseName}</td>
                                                        <td>{val.CityName}</td>
                                                        <td>{val.QtyEnd}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ):(
                        <></>
                    )
                }
                <div className="detail-container">
                    <div className="detail-header">Product Detail</div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Code</div>
                        <div className="detail-val">: {itemCode}</div>
                    </div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Color</div>
                        <div className="detail-val">: {itemColor}</div>
                    </div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Size</div>
                        <div className="detail-val">: {itemSize}</div>
                    </div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Capacity (ml)</div>
                        <div className="detail-val">: {itemCapacity}</div>
                    </div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Weight (kg)</div>
                        <div className="detail-val">: {itemWeight}</div>
                    </div>
                    <div className="detail-flex-container">
                        <div className="detail-spec">Category</div>
                        <div className="detail-val">: {itemCategory}</div>
                    </div>
                    <div style={{height:"50px"}}></div>
                </div>
                <div className="detail-container" style={{marginBottom:"50px", display:"none"}}>
                    <div className="detail-header">Related Product</div>
                    <Slider {...settingsCategory}>
                        <div>
                            <img src={banner1} />
                            <p className="center">Product 1</p>
                        </div>
                        <div>
                            <img src={banner1} />
                            <p className="center">Product 2</p>
                        </div>
                        <div>
                            <img src={banner1} />
                            <p className="center">Product 3</p>
                        </div>
                        <div>
                            <img src={banner1} />
                            <p className="center">Product 4</p>
                        </div>
                        <div>
                            <img src={banner1} />
                            <p className="center">Product 5</p>
                        </div>
                    </Slider>
                    
                </div>
                <div className="detail-footer center">
                    <button className={`btn ${THEME_COLOR}`} onClick={addToCart}> Add To Cart</button>
                </div>
            </div>
        </React.StrictMode>
    )

}

export default Item;
